import { render, staticRenderFns } from "./UpdateCase.vue?vue&type=template&id=4c84c841"
import script from "./UpdateCase.vue?vue&type=script&lang=js"
export * from "./UpdateCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports